import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton
} from "@mui/material";
import TextInput from "../../../Component/UI/TextInput/TextInput";
import classes from "./MUIMultiItemBox.module.css"
import CloseIcon from "@mui/icons-material/Close";
const NO_SPECIAL_CHARS_REGEX = /^[a-zA-Z0-9\s]+$/;

export default function AddItemModal({
  open,
  onClose,
  onSave,
  title = "Add Item",
  fields = [],
  useObjectFormat = false,
  saveBtnLabel = "Add",
}) {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    if (open) {
      const initial = {};
      fields.forEach((f) => {
        if (f.defaultValue !== undefined) {
          initial[f.name] = f.defaultValue;
        }
      });
      setFormData(initial);
      setErrors({});
      setInitialData(initial);
    }
  }, [open]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const allRequiredFilled = fields.every(
    (f) => !f.required || formData[f.name]?.trim()
  );

  const isEditMode = saveBtnLabel === "Update";

  const hasChanges = fields.some(
    (f) => (formData[f.name] ?? "") !== (initialData[f.name] ?? "")
  );

  const isValid =
    Object.keys(errors).length === 0 &&
    allRequiredFilled &&
    (isEditMode ? hasChanges : true);

  const handleSave = () => {
    if (useObjectFormat) {
      // pass the full formData object
      onSave(formData);
    } else {
      // pass only the raw value of the first field
      const firstFieldName = fields[0]?.name;
      onSave(formData[firstFieldName] || "");
    }
  };

  return (
   <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { position: "relative" } }}>
      <DialogTitle>
        {title}
      <IconButton
    onClick={onClose}
    sx={{ position: "absolute", right: 8, top: 8 }}
  >
    <CloseIcon />
  </IconButton>
      </DialogTitle>

      <DialogContent>
         <div className={classes.divContainer}>
        {fields.map((field) => (
          <TextInput
            key={field.name}
            label={field.label}
            fullWidth
            required={field.required}
            multiline={field.multiline}
            rows={field.rows || 3}
            margin="dense"
            disabled={field.disabled || false}
            value={formData[field.name] || ""}
            onChange={(e) => handleChange(field.name, e.target.value)}
            error={!!errors[field.name]}
            helperText={errors[field.name] || " "}
          />
        ))}
        </div>
      </DialogContent>

      <DialogActions sx={{ paddingBottom: "20px" }}>
        <Button onClick={onClose} variant="outlined" color="primary">Cancel</Button>
        <Button
          variant="contained"
          disabled={!isValid}
          onClick={handleSave}
        >
          {saveBtnLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}